import styled from 'styled-components';

import {THEME} from '../../weave/common/css/color.styles';

export const StyledButtonWrapper = styled.div`
  cursor: pointer;
  height: 24px;
  width: 24px;

  margin-right: 8px;

  :hover {
    color: ${THEME.accent};
  }
`;
